// export const ANIMATION = {
//   BULLET_STAGGER_DELAY: 0.05, // Delay between each bullet animation when showing/hiding (stagger effect)
//   BULLETS_HIDE_DELAY: 2000, // Delay before hiding help bullets after initial show
//   LABEL_ANIMATION_DELAY: 0.1, // Delay for label show/hide animations
// } as const

// export const ITEM_BULLET = {
//   FORCE_LEFT_DAYS: [4] as number[], // Days that force left-side labels to avoid covering characters
//   FORCE_RIGHT_DAYS: [7, 10] as number[], // Days that force right-side labels to avoid covering characters
// } as const

export const LAYER_TINTS = {
  DEFAULT: [0xeeeeee, 0xd2d2d2, 0xa2a2a2, 0x757575] as number[], // Default smoke tint colors (light to dark)
  WHITE_ONLY: [0xeeeeee] as number[], // White-only tint for specific layers
} as const

export const RESIZER = {
  DEBOUNCE_DELAY: 50, // Debounce delay for resize calculations (ms)
} as const

export const INPUT = {
  MOVE_EASE: 0.1, // Easing factor for input ratio interpolation
} as const

export type TouchShiftOffsets = Record<number, { left?: number; right?: number; top?: number; bottom?: number }>
